const tintColorLight = '#059669';
const tintColorDark = '#10b981';

const Colors = {
  light: {
    text: '#1e293b',
    background: '#ffffff',
    tint: tintColorLight,
    tabIconDefault: '#94a3b8',
    tabIconSelected: tintColorLight,
    card: '#ffffff',
    cardBackground: '#ffffff',
    border: '#e2e8f0',
    muted: '#64748b',
    accent: '#f59e0b',
    success: '#10b981',
    error: '#ef4444',
  },
  dark: {
    text: '#ffffff',
    background: '#0f172a',
    tint: tintColorDark,
    tabIconDefault: '#64748b',
    tabIconSelected: tintColorDark,
    card: '#1e293b',
    cardBackground: '#1e293b',
    border: '#334155',
    muted: '#94a3b8',
    accent: '#f59e0b',
    success: '#10b981',
    error: '#ef4444',
  },
};

export default Colors;
